<template>
  <Card
    v-if="isDisabled"
    :landlord-id="landlordId"
    :tenancy-id="tenancyId"
    :is-disabled="true"
    :accounting-summary="accountingSummary"
  />
  <router-link v-else :to="$options.SETTINGS_LINK" class="no-link-styles">
    <Card :landlord-id="landlordId" :tenancy-id="tenancyId" :accounting-summary="accountingSummary" />
  </router-link>
</template>

<script>
import Card from './Card.vue';

export default {
  components: {
    Card,
  },
  props: {
    landlordId: [String, Number],
    tenancyId: [String, Number],
    isDisabled: {
      type: Boolean,
      default: false,
    },
    accountingSummary: {
      type: Object,
      default: undefined,
    },
  },
  SETTINGS_LINK: {
    name: 'tenancy_payments',
  },
};
</script>
